<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,8C15,8,15,11,15,11C15,11,13,11,13,11C13,11,13,9,13,9C13,9,9,9,9,9C9,9,9,11,9,11C9,11,7,11,7,11C7,11,7,9,7,9C7,9,3,9,3,9C3,9,3,11,3,11C3,11,1,11,1,11C1,11,1,8,1,8C1,7.44772,1.44772,7,2,7C2,7,7,7,7,7C7,7,7,5,7,5C7,5,9,5,9,5C9,5,9,7,9,7C9,7,14,7,14,7C14.5523,7,15,7.44772,15,8C15,8,15,8,15,8ZM1,12C1,12,3,12,3,12C3.55228,12,4,12.4477,4,13C4,13,4,15,4,15C4,15.5523,3.55228,16,3,16C3,16,1,16,1,16C0.447715,16,6.76354e-17,15.5523,0,15C0,15,0,13,0,13C-6.76354e-17,12.4477,0.447715,12,1,12C1,12,1,12,1,12ZM13,12C13,12,15,12,15,12C15.5523,12,16,12.4477,16,13C16,13,16,15,16,15C16,15.5523,15.5523,16,15,16C15,16,13,16,13,16C12.4477,16,12,15.5523,12,15C12,15,12,13,12,13C12,12.4477,12.4477,12,13,12C13,12,13,12,13,12ZM7,12C7,12,9,12,9,12C9.55229,12,10,12.4477,10,13C10,13,10,15,10,15C10,15.5523,9.55229,16,9,16C9,16,7,16,7,16C6.44772,16,6,15.5523,6,15C6,15,6,13,6,13C6,12.4477,6.44772,12,7,12C7,12,7,12,7,12ZM7,1.40865e-32C7,1.40865e-32,9,1.40865e-32,9,1.40865e-32C9.55229,-1.01453e-16,10,0.447715,10,1C10,1,10,3,10,3C10,3.55228,9.55229,4,9,4C9,4,7,4,7,4C6.44772,4,6,3.55228,6,3C6,3,6,1,6,1C6,0.447715,6.44772,1.01453e-16,7,1.40865e-32C7,1.40865e-32,7,1.40865e-32,7,1.40865e-32Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DiagramTree',
} as DefineComponent
</script>
